module.exports = __webpack_public_path__ + "static/media/MSSbanner.cbf1c14e.jpg";